import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/unpublish.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm unpublish [<package-spec>]
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/unpublish.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <p>{`To learn more about how the npm registry treats unpublish, see our `}<a href="https://docs.npmjs.com/policies/unpublish" target="_blank" rel="noopener noreferrer">{` unpublish policies`}</a></p>
    <h3>{`Warning`}</h3>
    <p>{`Consider using the `}<a parentName="p" {...{
        "href": "/cli/v8/commands/npm-deprecate"
      }}><inlineCode parentName="a">{`deprecate`}</inlineCode></a>{` command instead,
if your intent is to encourage users to upgrade, or if you no longer
want to maintain a package.`}</p>
    <h3>{`Description`}</h3>
    <p>{`This removes a package version from the registry, deleting its entry and
removing the tarball.`}</p>
    <p>{`The npm registry will return an error if you are not `}<a parentName="p" {...{
        "href": "/cli/v8/commands/npm-adduser"
      }}>{`logged
in`}</a>{`.`}</p>
    <p>{`If you do not specify a version or if you remove all of a package's
versions then the registry will remove the root package entry entirely.`}</p>
    <p>{`Even if you unpublish a package version, that specific name and version
combination can never be reused. In order to publish the package again,
you must use a new version number. If you unpublish the entire package,
you may not publish any new versions of that package until 24 hours have
passed.`}</p>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`dry-run`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Indicates that you don't want npm to make any changes and that it should
only report what it would have done. This can be passed into any of the
commands that modify your local installation, eg, `}<inlineCode parentName="p">{`install`}</inlineCode>{`, `}<inlineCode parentName="p">{`update`}</inlineCode>{`,
`}<inlineCode parentName="p">{`dedupe`}</inlineCode>{`, `}<inlineCode parentName="p">{`uninstall`}</inlineCode>{`, as well as `}<inlineCode parentName="p">{`pack`}</inlineCode>{` and `}<inlineCode parentName="p">{`publish`}</inlineCode>{`.`}</p>
    <p>{`Note: This is NOT honored by other network related commands, eg `}<inlineCode parentName="p">{`dist-tags`}</inlineCode>{`,
`}<inlineCode parentName="p">{`owner`}</inlineCode>{`, etc.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`force`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Removes various protections against unfortunate side effects, common
mistakes, unnecessary performance degradation, and malicious input.`}</p>
    <ul>
      <li parentName="ul">{`Allow clobbering non-npm files in global installs.`}</li>
      <li parentName="ul">{`Allow the `}<inlineCode parentName="li">{`npm version`}</inlineCode>{` command to work on an unclean git repository.`}</li>
      <li parentName="ul">{`Allow deleting the cache folder with `}<inlineCode parentName="li">{`npm cache clean`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Allow installing packages that have an `}<inlineCode parentName="li">{`engines`}</inlineCode>{` declaration requiring a
different version of npm.`}</li>
      <li parentName="ul">{`Allow installing packages that have an `}<inlineCode parentName="li">{`engines`}</inlineCode>{` declaration requiring a
different version of `}<inlineCode parentName="li">{`node`}</inlineCode>{`, even if `}<inlineCode parentName="li">{`--engine-strict`}</inlineCode>{` is enabled.`}</li>
      <li parentName="ul">{`Allow `}<inlineCode parentName="li">{`npm audit fix`}</inlineCode>{` to install modules outside your stated dependency
range (including SemVer-major changes).`}</li>
      <li parentName="ul">{`Allow unpublishing all versions of a published package.`}</li>
      <li parentName="ul">{`Allow conflicting peerDependencies to be installed in the root project.`}</li>
      <li parentName="ul">{`Implicitly set `}<inlineCode parentName="li">{`--yes`}</inlineCode>{` during `}<inlineCode parentName="li">{`npm init`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Allow clobbering existing values in `}<inlineCode parentName="li">{`npm pkg`}</inlineCode></li>
      <li parentName="ul">{`Allow unpublishing of entire packages (not just a single version).`}</li>
    </ul>
    <p>{`If you don't have a clear idea of what you want to do, it is strongly
recommended that you do not use this option!`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspace`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default:`}</li>
      <li parentName="ul">{`Type: String (can be set multiple times)`}</li>
    </ul>
    <p>{`Enable running a command in the context of the configured workspaces of the
current project while filtering by running only the workspaces defined by
this configuration option.`}</p>
    <p>{`Valid values for the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config are either:`}</p>
    <ul>
      <li parentName="ul">{`Workspace names`}</li>
      <li parentName="ul">{`Path to a workspace directory`}</li>
      <li parentName="ul">{`Path to a parent workspace directory (will result in selecting all
workspaces within that folder)`}</li>
    </ul>
    <p>{`When set for the `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` command, this may be set to the folder of a
workspace which does not yet exist, to create the folder and set it up as a
brand new workspace within the project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspaces`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or Boolean`}</li>
    </ul>
    <p>{`Set to true to run the command in the context of `}<strong parentName="p">{`all`}</strong>{` configured
workspaces.`}</p>
    <p>{`Explicitly setting this to false will cause commands like `}<inlineCode parentName="p">{`install`}</inlineCode>{` to
ignore workspaces altogether. When not set explicitly:`}</p>
    <ul>
      <li parentName="ul">{`Commands that operate on the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` tree (install, update, etc.)
will link workspaces into the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` folder. - Commands that do
other things (test, exec, publish, etc.) will operate on the root project,
`}<em parentName="li">{`unless`}</em>{` one or more workspaces are specified in the `}<inlineCode parentName="li">{`workspace`}</inlineCode>{` config.`}</li>
    </ul>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/package-spec"
        }}>{`package spec`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-deprecate"
        }}>{`npm deprecate`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-publish"
        }}>{`npm publish`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/registry"
        }}>{`npm registry`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-adduser"
        }}>{`npm adduser`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-owner"
        }}>{`npm owner`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-adduser"
        }}>{`npm login`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      